<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            dataValueFormatFilter="currency"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TotalPaymentsOrderHistory',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-money-bill-alt',
                title: 'Totals In Payments',
                load_url: '/dashboards/PaymentsHistory/',
                icon_data: [
                    {
//                        name: 'Orders ready to pay',
                        name: 'Orders Ready',
                        text_color: '#2A9D8F',
                    },
                    {
//                        name: 'Orders ready Amount',
                        name: 'Ready Amount',
                        text_color: '#264653',
                    },
                    {
                        name: 'Paid Today',
                        text_color: '#F4A261',
                    },
                    {
//                        name: 'Actual Value Today',
                        name: 'AV Today',
                        text_color: '#E76F51',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>